// Club+ App

$('strong:contains("Club+ App")').html(
  '<span class="tw-text-blue">Club</span><span class="tw-text-green">+</span> <span class="tw-text-blue">App</span>'
);

// document.addEventListener("DOMContentLoaded", function(){
//   console.log($('.wishlist-added'))
//   $('.wishlist-added').attr('title', 'Remove from favourites')
// });

document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
  anchor.addEventListener("click", function (e) {
    e.preventDefault();

    document.querySelector(this.getAttribute("href")).scrollIntoView({
      behavior: "smooth",
   });
  });
});

$(document).ready(() => {
  var count = 0;
  const nav = $("nav.tmenu_navbar ul.tmenu_nav li");
  const navActive = $("nav.tmenu_navbar ul.tmenu_nav li.tmenu_item--current");
  const pathName = window.location.pathname;

  if (navActive.length >= 2) {
    const navChecker = window.setInterval(() => {
      count++;
    }, 1000);
    if (count == 10 || nav.hasClass("tmenu_item--current")) {
      clearInterval(navChecker);

      nav
        .parent()
        .find(".tmenu_item--current")
        .each((item) => {
          const child = $(nav.parent().find(".tmenu_item--current")[item]);
          var childTitleSlug = child.children().attr("href");
          if (childTitleSlug == pathName && !child.hasClass("red")) {
            child.css({ "background-color": "#b7d439", color: "#1B2D6D" });
            child
              .children()
              .css({ "background-color": "#b7d439", color: "#1B2D6D" });
          }
        });
    }
  } else {
    if (!navActive.hasClass("red")) {
      navActive.css({ "background-color": "#b7d439", color: "#1B2D6D" });
      navActive
        .children()
        .css({ "background-color": "#b7d439", color: "#1B2D6D" });
    }
  }

  // Search fix
  $('form.search, form.search-form').on("submit", function () {
    location.reload();
  });
  $('form.search input.search__input, form.search-form input.search__input').on('keyup',function (e) {
    var key = e.which;
    if (key == 13) {
      // the enter key code
      location.reload();
    }
  });
});
